// Sportgramme
import React, { useEffect, useState, useRef } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
// Use the exact name from your SEC_01_02_coreAuthClient.js file
import { coreAuthClient } from "../pre/SEC_01_02_coreAuthClient"; 

const VerifyEmailPage = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const [status, setStatus] = useState("Verifying your account...");
    const hasRun = useRef(false); // 🔒 Prevents double execution

    const token = searchParams.get("token");

    useEffect(() => {
        // 🚫 React 18 StrictMode runs useEffect twice in dev — this guard stops the second call
        if (hasRun.current) return;
        hasRun.current = true;

        if (!token) {
            setStatus("No verification token found.");
            return;
        }

        const runVerification = async () => {
            try {
                // STRATEGY: Use the pre-built client instead of raw fetch
                // This method handles the SITE-KEY and BASE_URL automatically
                const result = await coreAuthClient.verifyEmail({ verificationToken: token });

                if (result.ok) {
                    setStatus("Email verified successfully! Redirecting to sign-in...");
                    setTimeout(() => navigate("/auth/sign-in"), 3000);
                } else {
                    // Pull the error message directly from your client's response
                    setStatus(result.message || "Verification failed. Link may be expired.");
                }
            } catch (err) {
                setStatus("A system error occurred while verifying your account.");
            }
        };

        runVerification();
    }, [token, navigate]);

    return (
        <div style={{ padding: "50px", textAlign: "center", fontFamily: "sans-serif" }}>
            <h2>Account Verification</h2>
            <p>{status}</p>
        </div>
    );
};

export default VerifyEmailPage;
